import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getApprovals } from './../../../reducers/approvals';
import { history } from './../../../configuration/store';
import Table from './../../table';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getClients } from '../../../reducers/clients';
import { dateToFloatingString } from '../../../utilities/dateTime';

import './approvals.css';
import { jobStatus } from '../../../utilities/jobStatus';
import { hideFilter } from '../../../utilities/filterJobExt';

class ApprovalsList extends React.Component {
    constructor(props) {
        super(props);

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
    }

    componentDidMount() {
        let { role, getApprovals, getClients } = this.props;
        getApprovals(role);
        getClients(role.id, 'all');
    }

    getICW2(job) {
        switch (jobStatus(job)) {
            case 'ic':
            case 'ic-continue-request':
                return 'ic';

            case 'w2':
                return 'w2';

            case 'dont-qualify-ic':
                return 'dq';

            default:
                return '??';
        }
    }

    getColumnDefinition() {
        const { clients } = this.props;

        return [
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: d => (
                    <div className="row name-column">
                        {d.user ? (
                            <div>
                                <div className="col-xs-12 name-cell ellipsis">
                                    {d.user.first_name} {d.user.last_name}
                                </div>
                                <div className="col-xs-12 email-cell ellipsis">{d.user.email}</div>
                            </div>
                        ) : (
                            <div className="col-xs-12 full-height-cell ellipsis">
                                <FormattedMessage {...messages.notProvided} />
                            </div>
                        )}
                    </div>
                ),
                size: 'col-sm-4 col-xs-10'
            },
            {
                label: <FormattedMessage {...messages.client} />,
                valueMap: d => {
                    let client = clients.find(c => c.id === d.client_id);
                    return (
                        <div className="full-height-cell ellipsis">{client && client.name ? client.name : <FormattedMessage {...messages.notProvided} />}</div>
                    );
                },
                size: 'col-sm-2 hidden-xs'
            },
            {
                label: <FormattedMessage {...messages.title} />,
                valueMap: d => <div className="full-height-cell ellipsis">{d.title}</div>,
                size: 'col-sm-2 hidden-xs'
            },
            {
                label: <FormattedMessage {...messages.startDate} />,
                valueMap: d => <div className="full-height-cell ellipsis">{dateToFloatingString(d.start_date, 'MMM D')}</div>,
                size: 'col-sm-2 hidden-xs'
            },
            {
                valueMap: d => <div className="full-height-cell ellipsis">{this.getICW2(d)}</div>,
                size: 'col-sm-1 hidden-xs'
            },
            {
                valueMap: d => (
                    <div className="full-height-cell">
                        <i className="material-icons" onClick={() => history.push(`/approval/${d.id}`)}>
                            rate_review
                        </i>
                    </div>
                ),
                size: 'col-xs-1 text-right'
            }
        ];
    }

    render() {
        const { approvals, clients } = this.props;
        const filteredApprovals = approvals.filter(hideFilter('approval'));

        if (!clients) {
            return null;
        }

        return (
            <div className="col-xs-12">
                <Table data={filteredApprovals} columns={this.getColumnDefinition()} />
            </div>
        );
    }
}

ApprovalsList.defaultProps = {
    role: undefined,
    clients: undefined,
    approvals: []
};

ApprovalsList.propTypes = {
    role: PropTypes.object,
    clients: PropTypes.array,
    approvals: PropTypes.array
};

const mapStateToProps = state => ({
    approvals: state.approvals && state.approvals.list,
    role: state.identity.role,
    clients: state.clients.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getApprovals,
            getClients
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalsList);



// WEBPACK FOOTER //
// ./src/components/lists/approvals/index.jsx